<template>

</template>

<script>
import cookieSetters from '../../../store/web/cookie/mutation-types';
import cookieGetters from '../../../store/web/cookie/getter-types';

export default {
  props: {
    requiredProps: Boolean,
    analyticsProps: Boolean,
    marketingProps: Boolean,
    facebookPixelProps: Boolean,
    acceptAllUrl: String,
    acceptSelectedUrl: String,
  },
  mounted() {
    this.$store.commit('cookie/' + cookieSetters.SET_REQUIRED, this.requiredProps);
    this.$store.commit('cookie/' + cookieSetters.SET_ANALYTICS, this.analyticsProps);
    this.$store.commit('cookie/' + cookieSetters.SET_MARKETING, this.marketingProps);
    this.$store.commit('cookie/' + cookieSetters.SET_FACEBOOK_PIXEL, this.facebookPixelProps);
    this.$store.commit('cookie/' + cookieSetters.SET_ACCEPT_ALL_URL, this.acceptAllUrl);
    this.$store.commit('cookie/' + cookieSetters.SET_ACCEPT_SELECTED_URL, this.acceptSelectedUrl);
  },
  computed: {
    analytics() {
      return this.$store.getters['cookie/' + cookieGetters.GET_ANALYTICS];
    },
    marketing() {
      return this.$store.getters['cookie/' + cookieGetters.GET_MARKETING];
    }
  },
  watch: {
    analytics(value) {
      if (this.analyticsProps) return; // already initialized
      if (!value) return; // do not initialize
      gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    },
    marketing(value) {
      if (this.marketingProps) return; // already initialized
      if (!value) return; // do not initialize
      if (this.facebookPixelProps) {
        fbq('consent', 'grant');
      }
    }
  }
}
</script>

<style>

</style>
